import React, { Component, Fragment } from "react";
import { FormattedMessage } from "react-intl";
import cn from "classnames";

import Upload from "./Upload";
import Systems from "./Systems";
import Bars from "./Bars";
import NonBars from "./NonBars";
import Same from "./Same";
import Size from "./Size";
import Layout from "./Layout";

import Icon from "../../../../../../icon";

import messages from "./messages";
import {
    Progress,
    Point,
    Tick,
    Line,
    ScoreEditorWrapper,
    Back,
    Next,
    HelpWrapper,
    Help,
    HelpDescription,
} from "./styles";
import {
    getStage,
    isAvailableStage,
    maxStage,
    getIndicesOf,
    stages,
} from "./utils";
import {
    IBarsortingTask,
    IProps,
    IState,
} from "./interfaces";
import { IBarsortingData } from "../../../../../../../common/types";

class ScoreEditor extends Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        const { plan, taskIndex } = props;
        const task = plan.tasks[taskIndex];
        // upload
        let stage = "upload";

        if (task.data) {
            const data = task.data as IBarsortingData;
            if (data.systems) {
                stage = "systems";
            }
            if (data.bars) {
                stage = "bars";
            }
            if (data.nonBars) {
                stage = "non-bars";
            }
            if (data.sameTypes) {
                stage = "same";
            }
            if (data.scale) {
                stage = "size";
            }
            if (data.drags) {
                stage = "layout";
            }
        }

        let latestStage = stage;
        this.state = {
            stage,
            latestStage,
        };
    }
    setLatestStage = () => {
        this.setState({
            latestStage: this.state.stage,
        });
    };
    render() {
        const {
            taskIndex,
            plan,
            intl: { formatMessage },
        } = this.props;
        const { stage, latestStage } = this.state;
        const task = plan.tasks[taskIndex] as IBarsortingTask;
        const description = formatMessage(messages.description);
        const starts = getIndicesOf(description, "<ul>");
        const ends = getIndicesOf(description, "</ul>");
        const data = task.data as IBarsortingData;
        return (
            <ScoreEditorWrapper>
                <Progress>
                    {stages(formatMessage).map((st, index) => {
                        let property = st[0] as string;
                        let isAvailable = isAvailableStage(latestStage, property, formatMessage);
                        return (
                            <Fragment key={index}>
                                <Point
                                    key={index}
                                    className={cn(stage === property && "Active", isAvailable && "Selectable")}
                                    onClick={() => {
                                        if (isAvailable) {
                                            this.setState({ stage: property });
                                        }
                                    }}
                                >
                                    {isAvailable && (
                                        <Tick>
                                            <Icon i="tick" />
                                        </Tick>
                                    )}
                                    <div className={"Label"}>
                                        {st[1] as string}
                                        <HelpWrapper>
                                            <Help>?</Help>
                                            <HelpDescription
                                                left={index === stages(formatMessage).length - 1}
                                                className={"HelpDescription"}
                                                dangerouslySetInnerHTML={{
                                                    __html: description.slice(
                                                        starts[(stages(formatMessage)[index][2] as { start: number, end: number }).start],
                                                        ends[(stages(formatMessage)[index][2] as { start: number, end: number }).end] + 5
                                                    ),
                                                }}
                                            ></HelpDescription>
                                        </HelpWrapper>
                                    </div>
                                </Point>
                                {index < stages(formatMessage).length - 1 && <Line />}
                            </Fragment>
                        );
                    })}
                </Progress>
                {stage === "upload" && (
                    <Upload taskIndex={taskIndex} setLatestStage={this.setLatestStage} plan={plan} task={task} />
                )}
                {stage === "systems" && (
                    <Systems taskIndex={taskIndex} setLatestStage={this.setLatestStage} plan={plan} task={task} />
                )}
                {stage === "bars" && <Bars taskIndex={taskIndex} plan={plan} task={task} />}
                {stage === "non-bars" && <NonBars taskIndex={taskIndex} plan={plan} task={task} />}
                {stage === "same" && <Same taskIndex={taskIndex} plan={plan} task={task} />}
                {stage === "size" && <Size taskIndex={taskIndex} plan={plan} task={task}/>}
                {stage === "layout" && <Layout taskIndex={taskIndex} plan={plan} task={task} />}
                {stage !== "upload" && (
                    <Back
                        className={cn("button button--light")}
                        onClick={() => {
                            this.setState(
                                {
                                    stage: getStage(stage, -1, formatMessage),
                                },
                                () => {
                                    this.setState({
                                        latestStage: maxStage(latestStage, this.state.stage, formatMessage),
                                    });
                                }
                            );
                        }}
                    >
                        <FormattedMessage {...messages.back} />
                    </Back>
                )}
                {stage !== "layout" && (stage !== "upload" || (data && data.score)) && (
                    <Next
                        className={cn("button")}
                        onClick={() => {
                            this.setState(
                                {
                                    stage: getStage(stage, 1, formatMessage),
                                },
                                () => {
                                    this.setState({
                                        latestStage: maxStage(latestStage, this.state.stage, formatMessage),
                                    });
                                }
                            );
                        }}
                    >
                        <FormattedMessage {...messages.next} />
                    </Next>
                )}
            </ScoreEditorWrapper>
        );
    }
}

export default ScoreEditor;
